export const Quiz = {
  '题目题干要求': '题目题干要求',
  '正确答案': '参考答案',
  '答案公布时间': '答案公布时间',
  '多模态知识卡': '多模态知识卡',
  '答题设置': '答题设置',
  '分值设置': '分值设置',
  '满分值': '满分值',
  '直接回答': '直接回答',
  '提示回答': '提示回答',
  '公布后参与': '公布后参与',
  '分': '分',
  '题目': '题目',
  '点击知识卡可学习相关知识点': '点击知识卡可学习相关知识点',
  '请选择答题方式': '请选择答题方式',
  '选择后不可更改请谨慎选择': '选择后不可更改，请谨慎选择',
  '由自己独立完成作答': '由自己独立完成作答',
  'AI将提供引导式指导帮助作答': 'AI将提供引导式指导帮助作答',
  '最高可得': '最高可得 ',
  '满分': '满分',
  '满分的': '满分的',
  '答案将于': '答案将于 ',
  '公布': ' 公布',
  '公布答案后参与最高可得': '公布答案后参与最高可得 ',
  '你选择了直接回答模式': '你选择了【直接回答】模式，',
  '你选择了提示回答模式': '你选择了【提示回答】模式，',
  '我的回答': '我的回答',
  '请输入你的回答': '请输入你的回答...',
  '上传附件': '上传附件',
  '确认提交': '确认提交',
  'AI学习助手': 'AI学习助手',
  '正在加载AI助手': '正在加载AI助手...',
  '待评分': '待评分',
  '参考答案': '参考答案',
  '相关知识卡': '相关知识卡',
  '点击查看': '点击查看',
  '操作失败': '操作失败',
  '提交后不可修改确认提交': '提交后不可修改，确认提交？',
  '提交失败': '提交失败',
  '答题统计': '答题统计',
  '已答题': '已答题',
  '未答题': '未答题',
  '已评分': '已评分',
  '平均分': '平均分',
  '最高分': '最高分',
  '最低分': '最低分',
  '答题方式分布': '答题方式分布',
  '人': '人',
  '答题型话题标签': '答题型话题',
  '参考资料': '参考资料',
  '参考资料说明': '为学生提供辅助学习资料，支持多模态知识卡和文件附件',
  '暂无参考资料': '暂无参考资料',
  '同学作答': '同学作答',
  '暂无其他同学提交': '暂无其他同学提交',
  '上传失败': '上传失败',
  '学生作答详情': '学生作答详情',
  '刷新': '刷新',
  'AI引导智能体': 'AI引导智能体',
  '确认转换': '确认转换',
  '答题模式说明': '答题型话题包含3种答题模式：',
  '请输入题目题干要求': '请输入题目题干要求',
  '请输入正确答案': '请输入参考答案',
  '答案已公布参与最高可得': '答案已公布，现在参与最高可得 ',
  '公布后参与答题': '公布后参与答题',
  'AI助手暂不可用请直接作答': 'AI助手暂时不可用，请直接作答',
  '已选择': '已选择',
  '你选择了公布后参与模式': '你选择了【公布后参与】模式，',
  '暂无参考答案': '老师未提供参考答案',
  '老师未提供参考答案提示': '答案公布时间已到，但老师暂未设置参考答案内容',
  '确认选择答题方式': '确认选择答题方式',
  '选择此方式后不可更改': '选择此方式后不可更改，确认选择',
  '知识卡': '知识卡',
  '文件': '文件',
  '暂无题干内容': '暂无题干内容',
  '答案将于时间公布': '答案将于该时间公布',
  '加载中': '加载中...',
  '提交成功': '提交成功',
  '选择模式成功': '已成功选择答题方式',
  '暂无作答': '暂无作答',
  '姓名': '姓名',
  '学号': '学号',
  '答题方式': '答题方式',
  '得分': '得分',
  '提交时间': '提交时间',
  '展开查看': '展开查看',
  '暂无附件': '暂无附件',
  '普通话题': '普通话题',
  '答题型话题': '答题型话题',
  '话题类型': '话题类型',
  '转为答题型话题': '转为答题型话题',
  '转为普通话题': '转为普通话题',
  '转为普通话题提示': '转换后将删除答题配置，确认转换为普通话题？',
  '转换成功': '转换成功',
  '转换提示': '转换后，该话题将增加答题功能，学生需进行作答。',
  '原话题内容': '原话题内容',
  '一键带入题干要求': '一键带入题干',
  '带入题干覆盖确认': '当前已有题干内容，是否覆盖？',
  '已带入题干要求': '已带入题干要求',
  '暂无话题内容': '暂无话题内容',
  '题干附件': '题干附件',
  '参考资料文件': '参考资料（文件）',
  '参考答案附件': '参考答案附件',
  '答案公布时间不设置': '不设置（答题后即可查看）',
  '请选择AI引导智能体': '请选择AI引导智能体（必填）',
  '选择智能体': '选择智能体',
  '暂无可用智能体': '暂无可用AI引导智能体',
  '添加参考资料': '添加参考资料',
  '教学资料': '教学资料',
  '选择知识卡片': '选择知识卡片',
  '课程未绑定知识库': '当前课程未绑定多模态知识库',
  'AI引导智能体辅助说明': 'AI引导答题需要先选择一个可用智能体；若列表为空，请先前往添加或申请。',
  '搜索智能体': '搜索智能体',
  '前往添加智能体': '前往添加或申请',
  '无匹配智能体': '无匹配结果',
  topicDetailHasBody: '已填正文',
  topicDetailHasFiles: '含附件',
}
